import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "text-note",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "A free text with simple formatting: a message, a context note, a reminder.",
    domain: "general",
    visual: "Text",
    purposes: ["live", "reporting"],
    audiences: ["analyst", "client"],
  },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-3",
};
